import * as logger from 'loglevel';
import { getUuid } from '@front10/helpers/dist/uuid';
import dayjs from 'dayjs';
import axiosWrapper from '../../helpers/axiosWrapper';
import { xml2js } from 'xml-js';
import { buildQuery } from './utils/utils';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';
/**
 * Makes sure the cars response is complain with a basic schema
 * @param {*} cars
 */
const validateCarResponse = (carsXML) => {
  const validation = { isValid: true, message: '' };
  const carXmlParser = xml2js(carsXML);
  if (
    carXmlParser.elements &&
    Array.isArray(carXmlParser.elements) &&
    carXmlParser.elements[0] &&
    carXmlParser.elements[0].elements &&
    Array.isArray(carXmlParser.elements[0].elements)
  ) {
    carXmlParser.elements[0].elements.forEach((element) => {
      if (element.name === 'caritems') {
        if (!Array.isArray(element.elements)) {
          validation.isValid = false;
          validation.message =
            'INTEGRATION__CARS: CarItem SCHEMA is invalid, please check Fares API documentation.';
        } else {
          validation.data = element.elements;
        }
      }
    });
  } else {
    validation.isValid = false;
    validation.message =
      'INTEGRATION__CARS: FareItem SCHEMA is invalid, please check Fares API documentation.';
  }
  return validation;
};

const getDataTransformed = (dataRaw, type) => {
  if (dataRaw.name === type && Array.isArray(dataRaw.elements) && dataRaw.elements[0].text) {
    return dataRaw.elements[0].text;
  } else {
    logger.error(`INTEGRATION__CAR__RENTAL: No ${type} value found`, dataRaw);
    return '';
  }
};

const getNameDescriptionTransformed = (dataRaw) => {
  let { model, description } = '';
  if (Array.isArray(dataRaw.elements) && dataRaw.elements[0].text) {
    const dataSplit = dataRaw.elements[0].text.split(' ');
    if (dataSplit.length > 2) {
      description = `${dataSplit[dataSplit.length - 2]} ${dataSplit[dataSplit.length - 1]}`;
      dataSplit.splice(dataSplit.length - 2, 2);
      model = dataSplit.join(' ');
    } else {
      logger.error(
        `INTEGRATION__CAR__RENTAL: Some errors were found when unstructured MODEL and DESCRIPTION value`,
        dataRaw
      );
    }
  } else {
    logger.error(`INTEGRATION__CAR__RENTAL: No name value found`, dataRaw);
  }
  return { model, description };
};

const carItemMap = {
  image: 'image',
  currency: 'currency',
  price: 'formattedTotalPrice',
  link: 'deeplink'
};

/**
 * The group routes API returns the data in non linear format
 * so this function will intend normalize the data for the components
 * @param {*} routesRawData
 * @param {*} query
 */
const transformData = (carsRawData) => {
  const cars = [];
  carsRawData.forEach((car) => {
    let carTransformed = { index: getUuid() };
    car.elements.forEach((carItem) => {
      //TODO: This fix was necessary since the model and description are contained in the same variable from the API
      if (carItem.name === 'name') {
        const { model, description } = getNameDescriptionTransformed(carItem);
        carTransformed = { model, description, ...carTransformed };
      } else {
        carTransformed[carItemMap[carItem.name]] = getDataTransformed(carItem, carItem.name);
      }
    });

    cars.push(carTransformed);
  });
  return cars;
};

/**
 * Retrieve fares from the GroupRoutes Endpoint
 * @param {*} filter
 * @param {*} integrationSettings
 */
const getCars = (filter, meta, integrationSettings, pageContext) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings** not specified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1CarRental } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = v1CarRental;
    const filterCopy = { ...filter };

    if (!v1CarRental || !v1CarRental.method || !v1CarRental.endPoint || !v1CarRental.headers) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.v1CarRental** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    filterCopy.languageCode = filterCopy.languageCode.toUpperCase();
    if (!filterCopy.departureDate) {
      filterCopy.departureDate = new dayjs().format('YYYY-MM-DD');
    }

    const params = buildQuery(filterCopy);

    axiosWrapper(
      {
        method: v1CarRental.method,
        url: `${v1CarRental.endPoint}?${params}`,
        headers: { ...v1CarRental.headers }
      },
      {
        resource: 'INTEGRATION__CAR__RENTAL__GET__ITEMS',
        meta,
        integrationSettings,
        pageContext,
        cache,
        cacheDuration
      }
    )
      .then((response) => {
        const validation = validateCarResponse(response.data);
        if (validation.isValid) {
          logger.info('INTEGRATION__CAR__RENTAL: Successful request', response.data);
          const cars = transformData(validation.data);
          resolve(cars);
        } else {
          logger.error(validation.message, validation.data);
          reject(response.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getCars, transformData };
